import {
  Avatar,
  AvatarFallback,
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Form,
} from "@bleu.builders/ui";
import { truncate } from "lodash";
import { usePostHog } from "posthog-js/react";
import React from "react";
import { useForm } from "react-hook-form";

import { OrganizationScopedLink } from "#/components/Link";
import { useUser } from "#/contexts/UserContext";
import { AdminPagePath, UserPagePath } from "#/lib/pagesHelper";

function abbreviateName(firstName, lastName = "") {
  if (!firstName) return "CF";
  const parts = (firstName + " " + lastName).split(" ");
  return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
}

export function UserNav() {
  const { user } = useUser();
  const form = useForm();
  const posthog = usePostHog();

  const credits = user.organization.available_credits_amount;
  const creditsLabel = credits === 1 ? "crédito" : "créditos";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative size-8 rounded-full">
          <Avatar className="size-8">
            <AvatarFallback>
              {abbreviateName(user.first_name, user.last_name)}
            </AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-40" align="end" forceMount>
        <DropdownMenuLabel className="font-normal ">
          <div className="flex flex-col space-y-1">
            <p className="text-sm font-medium leading-none">
              {user.first_name}
            </p>
            <p className="text-muted-foreground text-xs leading-none">
              {credits > 0 ? (
                <OrganizationScopedLink
                  className="hover:underline hover:underline-offset-2"
                  to={UserPagePath.ORGANIZATION_TRANSACTIONS}
                >
                  {credits} {creditsLabel}
                </OrganizationScopedLink>
              ) : (
                <span>Nenhum crédito disponível</span>
              )}
            </p>
            <p className="text-muted-foreground text-xs leading-none">
              {truncate(user.email, {
                length: 21,
              })}
            </p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <OrganizationScopedLink
            to={UserPagePath.ORGANIZATION_PROFILE_SETTINGS}
          >
            <DropdownMenuItem>Configurações</DropdownMenuItem>
          </OrganizationScopedLink>
        </DropdownMenuGroup>
        {user.is_admin && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <OrganizationScopedLink to={AdminPagePath.THESES}>
                <DropdownMenuItem className="link:text-yellow-500">
                  Ir para painel admin
                </DropdownMenuItem>
              </OrganizationScopedLink>
            </DropdownMenuGroup>
          </>
        )}
        <DropdownMenuSeparator />
        <Form action={"/login/logout"} method="post" {...form}>
          <button
            type="submit"
            className="hover:bg-accent hover:text-accent-foreground transition-color relative flex w-full cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none"
            onClick={() => posthog.reset()}
          >
            Sair
          </button>
        </Form>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
